import Vue from 'vue';
import VueRouter from 'vue-router';
import NotFoundComponent from '../views/NotFound.vue';
import {HttpService} from '@/services/api';

Vue.use(VueRouter);

const routes = [
  {path: '*', component: NotFoundComponent},
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/Home.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/main',
    name: 'main',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/Home.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/time-bank',
    name: 'time-bank',
    component: () => import(/* webpackChunkName: "about" */ '../views/TimeBank.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue'),
  },
  {
    path: '/register-2',
    name: 'register-2',
    component: () => import(/* webpackChunkName: "about" */ '../components/register/SteppersFive.vue'),
  },
  {
    path: '/register-3',
    name: 'register-3',
    component: () => import(/* webpackChunkName: "about" */ '../components/register/SteppersSix.vue'),
  },
  {
    path: '/register-4',
    name: 'register-4',
    component: () => import(/* webpackChunkName: "about" */ '../components/register/SteppersSeven.vue'),
  },
  {
    path: '/already-register',
    name: 'already-register',
    component: () => import(/* webpackChunkName: "about" */ '../components/register/AlreadyRegister.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/news-activity',
    name: 'news-activity',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsActivity.vue'),
  },
  {
    path: '/news-activity-detail/:id',
    name: 'news-activity-detail',
    component: () => import(/* webpackChunkName: "product-detail" */ '../components/news-activity/Detail.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/profile-edit',
    name: 'profile-edit',
    component: () => import(/* webpackChunkName: "about" */ '../views/edit-profile/EditProfile.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/profile/service-provider/:id',
    name: 'service-provider',
    component: () => import(/* webpackChunkName: "about" */ '../components/profile/ServiceProvider.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/profile/service-receiver/:id',
    name: 'service-receiver',
    component: () => import(/* webpackChunkName: "about" */ '../components/profile/ServiceReceiver.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/invite-notification',
    name: 'invite-notification',
    component: () => import(/* webpackChunkName: "about" */ '../views/notification/InviteNotification.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/invite-detail/:id',
    name: 'invite-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/notification/InviteDetail.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/history-activity',
    name: 'history-activity',
    component: () => import(/* webpackChunkName: "about" */ '../views/history-activity/HistoryList.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/activity/:id',
    name: 'activity',
    component: () => import(/* webpackChunkName: "about" */ '../views/history-activity/ActivityConfirm.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "about" */ '../views/search/search.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/service-search',
    name: 'service-search',
    component: () => import(/* webpackChunkName: "about" */ '../components/search/service-search.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/service-search-result',
    name: 'service-search-result',
    component: () => import(/* webpackChunkName: "about" */ '../components/search/service-search-result.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "about" */ '../views/test.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import(/* webpackChunkName: "about" */ '../views/ChangePassword.vue')
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-menu',
    name: 'payment-menu',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-menu.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-select',
    name: 'payment-select',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-select.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-code-generated',
    name: 'payment-code-generated',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-code-generated.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-code-generate-end',
    name: 'payment-code-generate-end',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-code-generated-end.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-code-verify',
    name: 'payment-code-verify',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-code-verify.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-code-verify-end',
    name: 'payment-code-verify-end',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-code-verify-end.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-final-information',
    name: 'payment-final-information',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-final-information.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-information',
    name: 'payment-information',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-information.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/payment-rating',
    name: 'payment-rating',
    component: () => import(/* webpackChunkName: "about" */ '../views/payment/payment-rating.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/transfer',
    name: 'transfer',
    component: () => import(/* webpackChunkName: "about" */ '../views/transfer.vue'),
    beforeEnter: authorizationMiddleware
  },
  {
    path: '/transfer/:id',
    name: 'transfer-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/transfer-detail.vue'),
    beforeEnter: authorizationMiddleware
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;

async function authorizationMiddleware(to: any, from: any, next: any): Promise<void> {
  try {
    if (!await HttpService.Authorization()) {
      next('/');
    } else {
      if (await HttpService.weakPassword()) {
        next('/change-password');
      } else {
        next();
      }
    }
  } catch (e) {
    next('/');
  }
}


